// FirmaPad.js
import React, { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import './FirmaPad.css';

const FirmaPad = ({ onSave }) => {
  const sigRef = useRef(null);

  const clear = () => {
    sigRef.current.clear();
    if (onSave) {
      onSave(null);
    }
  };

  const handleEnd = () => {
    if (onSave && sigRef.current) {
      const signatureData = sigRef.current.toDataURL();
      onSave(signatureData);
    }
  };

  return (
    <div className="firma-container">
      <SignatureCanvas
        ref={sigRef}
        penColor="black"
        onEnd={handleEnd}
        canvasProps={{
          width: 373,
          height: 200,
          className: 'firma-canvas',
        }}
      />
      <button type="button" onClick={clear}>
        <FontAwesomeIcon icon={faTrash} />
      </button>
    </div>
  );
};

export default FirmaPad;
